<template>
<div class="main col s12 m9m" ref="infobox">
   <div class="row pad-in" style="min-height:100px;" >
      <div class="col s12 yo-text-bold">{{evento.titolo}}</div>
      <div class="col s12 yo-text-n yo-spacing-s " style="">{{evento.citta}},
        <span class="yo-text-n yo-spacing-s " v-if="evento.iniziail==evento.finisceil">{{evento.finisceil | data('DD MMMM YYYY')}}</span>
        <span class="yo-text-n yo-spacing-s " v-if="evento.iniziail!=evento.finisceil">{{evento.iniziail | data('DD MMMM')}} - {{evento.finisceil | data('DD MMMM YYYY')}}</span>
      </div>
   </div>
</div>
</template>

<script>
export default {
   props: {evento: Object,rowheight: Number},
   mounted() {
      var parent= this
      this.$emit('change', this.$refs.infobox.clientHeight)
      this.$teras.event.on('appResize', () => {
         console.log(parent.$refs.infobox) 
         parent.$emit('change', parent.$refs.infobox.clientHeight)
      })
  }
}






</script>


// WEBPACK FOOTER //
// src/components/Evento-elenco-titolo-res.vue